var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.75C8 13.3438 8.3125 13 8.75 13H15.25C15.6562 13 16 13.3438 16 13.75C16 14.1875 15.6562 14.5 15.25 14.5H8.75C8.3125 14.5 8 14.1875 8 13.75ZM12.25 16C12.6562 16 13 16.3438 13 16.75C13 17.1875 12.6562 17.5 12.25 17.5H8.75C8.3125 17.5 8 17.1875 8 16.75C8 16.3438 8.3125 16 8.75 16H12.25ZM9.75 7H14.25V5.75C14.25 5.34375 14.5625 5 15 5C15.4062 5 15.75 5.34375 15.75 5.75V7H17C18.0938 7 19 7.90625 19 9V19C19 20.125 18.0938 21 17 21H7C5.875 21 5 20.125 5 19V9C5 7.90625 5.875 7 7 7H8.25V5.75C8.25 5.34375 8.5625 5 9 5C9.40625 5 9.75 5.34375 9.75 5.75V7ZM6.5 19C6.5 19.2812 6.71875 19.5 7 19.5H17C17.25 19.5 17.5 19.2812 17.5 19V11H6.5V19Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.adf2dd4da1d94888107f62881b2b3fe1.svg";
export { ForwardRef as ReactComponent };